document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".tab-links a");
  const tabContent = document.querySelectorAll(".tab");
  const firstTab = document.querySelector(".tab-links .active a");

  // Function to activate a tab
  function activateTab(link) {
    // Remove active class from all tab links and tab contents
    tabLinks.forEach(function (link) {
      link.parentElement.classList.remove("active");
    });

    tabContent.forEach(function (content) {
      content.classList.remove("active");
    });

    // Add active class to the clicked tab link and corresponding tab content
    link.parentElement.classList.add("active");
    const target = document.querySelector(link.getAttribute("href"));
    target.classList.add("active");
    target.style.border = "none";
  }

  // Add click event listeners to all tab links
  tabLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      activateTab(link);
    });
  });

  // Automatically activate the first tab
  if (firstTab) {
    activateTab(firstTab);
  }
});
